import script from "./Ga4ReportPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./Ga4ReportPage.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__